import {
  Container,
  Title,
  TitleDescription,
  TitlesContainer
} from '@/pages/LoginFlow/SignUp/SignUpStyles';

const signUpVerifyError = () => (
  <Container>
    <TitlesContainer>
      <Title>Your Invitation expired</Title>
      <TitleDescription>
        Please contact support@thejourneyplatform.com to receive a new invitation
      </TitleDescription>
    </TitlesContainer>
  </Container>
);

export default signUpVerifyError;
